<template>
<!--案例详情-->
    <div class="c-main-detailbox">
      <div class="back" @click="$router.back(-1)">
        <i class="el-icon-back" style="cursor:pointer"> 返回 </i>
      </div>
     <!--  <div class="c-x-scroll">
        <ul class="c-main-topnav">
          <li><a href="javascript:;">找项目</a></li>
          <li><a href="javascript:;">找专家</a></li>
          <li><a href="javascript:;">找资金</a></li>
          <li><a href="javascript:;">获担保</a></li>
          <li><a href="javascript:;">看政策</a></li>
          <li class="active"><a href="javascript:;">优秀案例</a></li>
        </ul>
      </div> -->

        <!-- <div class="c-detail-top-box">
          <div class="c-detial-left">
              <img :src="imgPreviews[0]">
              <div class="c-gs-detail">
                 <img src="../../assets/main/gs-log.png">
                 <div class="c-gs-txt">
                    <p>{{caseInfo.caseName}}</p>
                    <div class="c-qiye">
                        <a href="#">了解企业</a>
                        <a href="#">关注企业</a>
                    </div>
                 </div>
              </div>
          </div> -->
          <div class="c-detail-top-box c-detail-top-box2">
            <div class="c-detial-left">
              <img :src="imgPreviews[0]">
              <div class="c-gs-detail">
                <img :src="caseInfo.org.logo">
                <div class="c-gs-txt" @click="openOrg">
                  <p>{{caseInfo.org.organization}}</p>
                </div>
              </div>
            </div>

          <div class="c-detial-right">
              <h2>{{caseInfo.caseName}}</h2>
              <p class="c-txt">{{caseInfo.caseContent}}</p>
              <div class="c-time">
                <p>发布时间：{{caseInfo.createTime}}</p>
                <!-- <p>截止日期：2020-07-18   00:42</p> -->
              </div>
              <div class="c-price-btn">
                  <p>合同金额：<span>{{caseInfo.nonamount?'价格保密':(caseInfo.amountUpper/10000)+'万元'}}</span></p>
                  <!-- <a href="#">类似项目</a> -->
              </div>
          </div>
        </div>

        <div class="c-detail-list">
            <div class="c-detail-items">
                <h3>项目背景</h3>
                <p>{{caseInfo.background}}</p>
            </div>
            <div class="c-detail-items">
                <h3>主要解决问题</h3>
                <p>{{caseInfo.solving}}</p>
            </div>
            <div class="c-detail-items">
                <h3>建设思路</h3>
                <p>{{caseInfo.constructionThinking}}</p>
            </div>
            <div class="c-detail-items">
                <h3>建设成效</h3>
                <p>{{caseInfo.constructionEffect}}</p>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getCaseById,
} from '@/api/case';
import config from '@/config/index';
import { getCacheUserInfo } from '@/utils/auth';
import { MessageBox } from 'element-ui';
export default {
    name: 'SuccessCaseDetail',
    data() {
        return {
            caseInfo: {org: {}},
            imgKeys: [],
            imgPreviews: [],
        }
    },
    mounted() {
        this.cid = this.$route.query.cid;
        this.queryInfo(this.cid);
    },
    methods: {
        queryInfo(cid) {
            if (!cid) return;
            this.$http.get(getCaseById(cid)).then((res) => {
                if (res.code === 1) {
                    console.log(res);
                    this.caseInfo = res.data;
                    this.initData();
                }
            });
        },
        initData() {
            if (this.caseInfo) {
                const keys = Object.keys(this.caseInfo);
                keys.forEach((key) => {
                    this[key] = this.caseInfo[key];
                });
                if (this.logo && typeof this.logo === 'string') {
                    let imgs = JSON.parse(this.logo);
                    this.imgKeys = imgs;
                    if (imgs && imgs.length > 0) {
                        imgs = imgs.map((img) => {
                            return `${config.HOST_IMG}${img}`;
                        });
                    }
                    this.imgPreviews = imgs;
                }
                if (this.caseInfo.org) {
                  this.caseInfo.org.logo = `${config.HOST_IMG}${this.caseInfo.org.logo}`;
                } else {
                  this.caseInfo.org = {};
                }
            }
        },
        openOrg() {
          // console.log("openOrg")
          // MessageBox.alert('平台功能完全开放后可查看机构详情', '平台建设中', {
          //   confirmButtonText: '确定',
          //   callback: action => {
          //     MessageBox.message({
          //       type: 'info',
          //       message: `action: ${ action }`
          //     });
          //   }
          // });
          this.$router.push('/detail/org-detail?orgid='+this.caseInfo.orgid);
        }
    }
}
</script>


<style scoped>
@import url(./success-case-detail-m.css);
@import url(./success-case-detail.css);
</style>
